window.initializeSwiperWhenVisible('.block__success-stories-row', () => {
  new Swiper('.block__success-stories-row', {
    loop: true,
    slidesPerView: 4,
    paginationClickable: false,
    spaceBetween: 0,
    breakpoints: {
      992: {
        slidesPerView: 3,
        spaceBetween: 0,
      },
      749: {
        slidesPerView: 2,
        spaceBetween: 0,
      },
      0: {
        slidesPerView: 1,
        initialSlide: 1,
        spaceBetween: 10,
      },
    },
  });
});
